module.exports = __webpack_public_path__ + "static/img/RWDA1865-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWDA1865-G_1.png
// module id = jHmb
// module chunks = 0